export default __webpack_public_path__ + "static/media/triathlon.7a4eb282.svg";